import React from 'react';
import { Hero } from './components/Hero';
import { QuickProof } from './components/QuickProof';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
interface AppProps {
  showUrgency?: boolean;
}
export function App({
  showUrgency = true
}: AppProps) {
  return <div className="w-full bg-white" data-id="element-0" data-mp="2wjgp1comflds">
      <main data-id="element-1" data-mp="2wifgbev2vaz8">
        <Hero data-id="element-2" data-mp="2wip2ssgwz006" />
        <QuickProof data-id="element-3" data-mp="2wi5mfg6wwjo9" />
        <Problem data-id="element-4" data-mp="28u5vaf5our95" />
        <Solution data-id="element-5" data-mp="28tmifcuwat1z" />
        <WhatYouGet data-id="element-6" data-mp="28suumo7jhzm9" />
        <Bonuses data-id="element-7" data-mp="28sbbx5a2f776" />
        <Pricing showUrgency={showUrgency} data-id="element-8" data-mp="23vck4tdvjcc5" />
        <Testimonials data-id="element-9" data-mp="23u9qidp62vsj" />
        <Guarantee data-id="element-10" data-mp="23v2sz2h3ez4v" />
        <Faq data-id="element-11" data-mp="23ti6m04xmmi3" />
        <FinalCta showUrgency={showUrgency} data-id="element-12" data-mp="3ik7g4ghnibqn" />
      </main>
      <Footer data-id="element-13" data-mp="3ijpbavgxap74" />
    </div>;
}